import { Constraints, Option } from './_types';

export const constraintsByOption: Record<Option, Constraints> = {
  Week: {
    inputProps: {
      value: 1,
      readOnly: true,
    },
    formState: { type: 'Week', repeatEvery: 1, at: '00:00', on: ['Monday'] },
  },
  Day: {
    inputProps: {
      min: 1,
      max: 31,
    },
    formState: { type: 'Day', repeatEvery: 1, at: '00:00' },
  },
  Hour: {
    inputProps: {
      min: 1,
      max: 24,
    },
    formState: { type: 'Hour', repeatEvery: 1, startAtMinute: '00' },
  },
  Minute: {
    inputProps: {
      min: 1,
      max: 59,
    },
    formState: { type: 'Minute', repeatEvery: 1, startAt: '00:00' },
  },
  Month: {
    inputProps: {
      min: 1,
      max: 12,
    },
    formState: { type: 'Month', repeatEvery: 1, onDay: ['1'], at: '00:00' },
  },
  '--': {
    inputProps: {
      readOnly: true,
      placeholder: '--',
    },
    formState: { type: '--', repeatEvery: null },
  },
};
